import { ImageCollection } from "common/config/media.config";
import useProfile from "common/hooks/useProfile";
import { FC, useEffect, useRef, useState } from "react";
import useOnClickOutside from "common/hooks/useOnClickOutside";
import { useNavigate } from "react-router-dom";
import { CharacterLength } from "common/enums/character-length.enum";
import useQuery from "common/hooks/useQuery";
import Avatar from "common/components/base/avatar";
import Search from "common/components/base/search/Search";
import { useAppDispatch, useAppSelector } from "common/redux/core";
import { userActions } from "common/redux/user";
import LogoutIcon from "@mui/icons-material/Logout";
import { documentSetupActions } from "modules/documents/data/redux/document-setup/document-setup.slice";
import { documentListActions } from "modules/documents/data/redux/document-list/document-list.slice";

import "./HeaderNew.scss";

type HeaderNewProps = {
  fixed?: boolean;
  onToggleSideNav?: () => void;
  showSearch: boolean;
  search?: {
    placeholder: string;
    path: string;
    action: any;
  };
};

const HeaderNew: FC<HeaderNewProps> = ({
  onToggleSideNav,
  showSearch,
  search
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const location = useQuery();
  const dispatch = useAppDispatch();
  const searchParm = location.get("search");
  const { avatar, displayName } = useProfile();
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const navigate = useNavigate();

  const { currentPageDetails: currentDocSetUpPageDetails } = useAppSelector(
    (state) => state.documentSetup
  );
  const { currentPageDetails: currentDocPageDetails } = useAppSelector(
    (state) => state.documentList
  );

  useOnClickOutside(ref, () => {
    setShowProfileOptions(false);
  });

  useEffect(() => {
    if (searchValue?.length === 0 && searchParm && search) {
      navigate(search.path);
    }
  }, [searchValue, searchParm]);

  const handlePageChange = (page: number) => {
    let details = {};

    details =
      search?.action === documentSetupActions
        ? currentDocSetUpPageDetails
        : currentDocPageDetails;

    dispatch(
      search?.action.setCurrentPageDetails({
        ...details,
        search: "",
        page
      })
    );
  };

  return (
    <>
      <div className="header-wrapper">
        {/* <h1 className="landing-page-header">AI Requirement Solutions Suite</h1> */}
        <h1 className="landing-page-header"></h1>

        {showSearch && (
          <Search
            value={searchValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSearchValue(e.target.value);
            }}
            onEnterOrSearchClick={() => {
              if (
                searchValue?.length >
                CharacterLength.MINIMUM_SEARCH_CHARACTER_LENGTH
              ) {
                navigate(`${search?.path}?search=${searchValue}`);
              }
            }}
            placeholder={search?.placeholder}
            className="header__search-bar"
            isEnableClear={searchValue?.length > 0}
            isClearButtonFaint={true}
            onClear={() => {
              setSearchValue("");
              if (
                (currentDocSetUpPageDetails?.search ||
                  currentDocPageDetails?.search) &&
                search
              ) {
                navigate(search.path);
                handlePageChange(1);
              }
            }}
          />
        )}
        <div className="icon-container">
          <div
            className="header_avatar"
            ref={ref}
            onClick={() => {
              setShowProfileOptions(!showProfileOptions);
            }}
          >
            <span
              style={{
                position: "relative",
                display: "inline-block"
              }}
            >
              <Avatar userName={displayName} src={avatar} />
            </span>
            {showProfileOptions && (
              <div className="header_avatar-options">
                <div className="profile-section">
                  <Avatar
                    userName={displayName}
                    src={avatar}
                    size="large"
                    className="header-avatar"
                  />
                  <div className="profile-name">
                    <p className="profile-name-role">{displayName}</p>
                  </div>
                </div>
                <div className="profile_logout">
                  <a
                    onClick={() => {
                      dispatch(userActions.logoutUserBegin());
                    }}
                  >
                    <LogoutIcon />
                    <span className="profile_logout__text">Log Out</span>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderNew;
